<template>
  <a-card  class="height-100-per" :bordered="false">
    <div style="text-align: right;">
      <a-icon type="close-circle" @click="hideworkshop" />
    </div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
          <a-form-item  label="车间名称"  >
            <j-input placeholder="请填写车间名称" v-model="queryParam.workshop" type="like" />
          </a-form-item>
          <a-form-item  label="是否启用"  >
            <j-dict-select-tag v-model="queryParam.status"  dictCode="on_off" placeholder="请选择是否启用"/>
          </a-form-item>
          <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload">重置</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡检车间配置表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <workshop-modal ref="modalForm" @ok="modalFormOk"></workshop-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkshopModal from '../modules/WorkshopModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { filterObj } from '@/utils/util';
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "WorkshopList",
    mixins:[JeecgListMixin],
    components: {
      WorkshopModal,JInput
    },
    data () {
      return {
        description: '巡检车间配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'车间名称',
            align:"center",
            dataIndex: 'workshop'
          },
          {
            title:'是否启用',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/workshop/busInspectionDepartWorkshop/list",
          delete: "/workshop/busInspectionDepartWorkshop/delete",
          deleteBatch: "/workshop/busInspectionDepartWorkshop/deleteBatch",
          exportXlsUrl: "/workshop/busInspectionDepartWorkshop/exportXls",
          importExcelUrl: "workshop/busInspectionDepartWorkshop/importExcel",
        },
        dictOptions:{},
        disableMixinCreated:true,
        choosedDepartRow:{

        }
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      initData(){

      },
      choosedDepart(record){
        this.initData()
        this.choosedDepartRow=record
        this.loadData(1);
      },
      handleEdit: function (record) {
        record.baseId=this.choosedDepartRow.baseId,
        record.departId=this.choosedDepartRow.departId,
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "编辑";
        this.$refs.modalForm.disableSubmit = false;
      },
      handleAdd: function (record) {
        record.baseId=this.choosedDepartRow.baseId
        record.departId=this.choosedDepartRow.departId
        this.$refs.modalForm.add(record);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
      getQueryParams () {
          //获取查询条件
          let sqp = {}
          if (this.superQueryParams) {
              sqp['superQueryParams'] = encodeURI(this.superQueryParams)
          }
          let queryParam=this.queryParam
          if(this.choosedDepartRow&&this.choosedDepartRow.departId){
            queryParam.departId=this.choosedDepartRow.departId
          }
          var param = Object.assign(sqp, queryParam, this.isorter, this.filters);
          param.field = this.getQueryField();
          param.pageNo = this.ipagination.current;
          param.pageSize = this.ipagination.pageSize;
          return filterObj(param);
      },
      hideworkshop(){
        this.$emit("close")
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
</style>